import { IntlShape } from 'react-intl';

// Translation helper which using react
// intl.formatMessage to provide text by id
const Msg = (intl: IntlShape, id: string): string => {
  return intl.formatMessage({ id });
};

export { Msg };
